import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import Button from '../button/button';
import EventDate from '../event-date/event-date';
import EventMeta from '../event-meta/event-meta';
import Link from '../link/link';
import VenueLabel from '../venue-label/venue-label';
import DiningData from '../dining-data/dining-data';

import styles from '../content-teaser/content-teaser.module.scss';

export const DefaultTeaser = ({
  data,
  image,
  nodeTypeName,
  distance,
  experience,
  cuisine,
  eventMeta,
}) => {
  const path = data?.path?.alias;
  const title = data?.title;
  const venue = data?.relationships?.field_venue;
  const summary = data?.body?.summary;

  const ctaText =
    nodeTypeName === 'Event'
      ? 'View Event'
      : nodeTypeName === 'Place'
        ? 'Discover'
        : 'Learn More';

  return (
    <>
      {path && (
        image && image.contentTeaser ? (
          <Link
            to={path}
            className={styles.imageLink}
            aria-label={`View details for ${title}`}
          >
            <Img
              alt=""
              className={styles.img}
              sizes={image.contentTeaser}
            />
          </Link>
        ) : image ? (
          <Link
            to={path}
            className={styles.imageLink}
            aria-label={`View details for ${title}`}
          >
            <img
              alt=""
              className={styles.img}
              src={image}
            />
          </Link>
        ) : null
      )}

      <h2 className={styles.title}>{title}</h2>

      {nodeTypeName === 'Event' && data?.date && (
        <EventDate className={styles.date} date={data.date} />
      )}

      {venue && (
        <VenueLabel
          venue={venue.title}
          path={venue.path?.alias}
        />
      )}

      {summary && <p className={styles.body}>{summary}</p>}

      {(distance || experience || cuisine) && (
        <DiningData
          distance={distance}
          experience={experience}
          cuisine={cuisine}
        />
      )}

      {eventMeta && (eventMeta.venue || eventMeta.series) && (
        <EventMeta
          className={styles.meta}
          venue={eventMeta.venue}
          series={eventMeta.series}
        />
      )}

      {data?.field_summary_only !== true && nodeTypeName && path && (
        <Button
          aria-label={`${ctaText}: ${title}`}
          className={styles.button}
          color="blueLight"
          to={path}
          textStyle="upper"
        >
          <span aria-hidden="true">{ctaText}</span>
        </Button>
      )}
    </>
  );
};

DefaultTeaser.propTypes = {
  data: PropTypes.object.isRequired,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  nodeTypeName: PropTypes.string,
  distance: PropTypes.string,
  experience: PropTypes.string,
  cuisine: PropTypes.string,
  eventMeta: PropTypes.shape({
    venue: PropTypes.string,
    series: PropTypes.string,
  }),
};

export default DefaultTeaser;